// extracted by mini-css-extract-plugin
export var form = "shop-module--form--3qd_e";
export var input = "shop-module--input--khZxO";
export var buttonWrapper = "shop-module--buttonWrapper--3HueI";
export var submitButton = "shop-module--submitButton--1aumO";
export var routeName = "shop-module--routeName--2JDfr";